var map = {
	"./blog.yml": 99,
	"./cloud.yml": 100,
	"./color.yml": 101,
	"./country.yml": 102,
	"./dio.yml": 103,
	"./doc.yml": 104,
	"./emoji.yml": 105,
	"./git.yml": 106,
	"./icon.yml": 107,
	"./license.yml": 108,
	"./link.yml": 109,
	"./metrics.yml": 110,
	"./people.yml": 111,
	"./soft.yml": 112,
	"./src.yml": 113,
	"./status.yml": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;